var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfoWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.34291 2.34309C5.46749 -0.781114 10.5329 -0.780883 13.6572 2.3429C16.7807 5.46757 16.7811 10.5327 13.6575 13.6573C10.5329 16.7809 5.46731 16.7808 2.34306 13.6575C-0.780809 10.5327 -0.78118 5.46716 2.34291 2.34309ZM6.83708 4.04189C6.82263 4.64832 7.28498 5.13956 7.9785 5.13956C8.70092 5.13956 9.16288 4.64832 9.16328 4.04189C9.14843 3.40656 8.70053 2.92977 7.99255 2.92977C7.28498 2.92977 6.82263 3.40616 6.83708 4.04189ZM7.99977 13.2178C8.6648 13.2178 9.20381 12.6788 9.20381 12.0138V7.19765C9.20381 6.53262 8.6648 5.99362 7.99977 5.99362C7.33474 5.99362 6.79574 6.53262 6.79574 7.19765V12.0138C6.79574 12.6788 7.33474 13.2178 7.99977 13.2178Z",
    fill: "#E39F55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoWarning);
export default __webpack_public_path__ + "static/media/info-warning.d4182b40e29e8ed6ca6b809a9972a9d0.svg";
export { ForwardRef as ReactComponent };